// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"e8e0a043bc25c77ee638","452":"a248e267672499eff063","453":"307b9ede5c188b08e0f2","522":"0406bd74f61ca353848e","551":"2e0d67c036fd00fd2417"}[chunkId] + ".js";
};